// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2gfZ0","title":"Header_title__1h2iC","side":"Header_side__2noBu"};